// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { DashboardGroupsResponse } from '@coa/app/home/modules/dashboard/modules/dashboard-groups/models/dashboard-groups-response';


export const dashboardGroupsRequested = createAction('[DASHBOARD GROUPS] Groups Requested', props<{
  timePeriod: DateRangeFilter,
  clientId: string,
  categoryId?: string
}>());
export const dashboardGroupsRequestSucceeded = createAction('[DASHBOARD GROUPS] Groups Request Succeeded', props<{
  customGroupsResponse: DashboardGroupsResponse
}>());
export const dashboardGroupsRequestFailed = createAction('[DASHBOARD GROUPS] Groups Request Failed');
